import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SalesChangesState {
  top_asins: string;
  expected_average: string;
  actual_average: string;
  seller_ids: string;
  toggle_switch_index: number;
}

export const initialState: SalesChangesState = {
  top_asins: "3",
  expected_average: "1",
  actual_average: "1",
  seller_ids: "",
  toggle_switch_index: 0,
};

export const salesChangesSlice = createSlice({
  name: "salesChangesStatus",
  initialState,
  reducers: {
    changeSalesChangesState: (
      state: SalesChangesState,
      action: PayloadAction<{
        top_asins: string;
        expected_average: string;
        actual_average: string;
      }>
    ) => {
      state.top_asins = action.payload.top_asins;
      state.actual_average = action.payload.actual_average;
      state.expected_average = action.payload.expected_average;
    },
    changeSalesChangesSellerId: (
      state: SalesChangesState,
      action: PayloadAction<string>
    ) => {
      state.seller_ids = action.payload;
    },
    changeToggleSwitchIndex: (
      state: SalesChangesState,
      action: PayloadAction<number>
    ) => {
      state.toggle_switch_index = action.payload;
    },
  },
});

export const {
  changeSalesChangesState,
  changeSalesChangesSellerId,
  changeToggleSwitchIndex,
} = salesChangesSlice.actions;
